import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import Card from "../../../components/Card";
import { toast } from 'react-toastify';
import { API_USERS_LIST, API_USERS_SIGNUP, API_SIGNUP_EMAIL_SEND_CODE, API_SIGNUP_EMAIL_VERIFY_CODE } from "../../../service/url";
import { postApiCall, getApiCall } from "../../../service/httpCall";
import { useNavigate } from "react-router-dom";
import { getUserCreateAccessRoleLabel, ifUserAssociateCompany, getUser } from "../../../utilities/setting";
import { ROUTES, USERS_ROLE } from "../../../utilities/constant";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { API_ACL_SETTING_LIST, API_COMPANY_LIST, API_CALL_CENTRE_LIST, API_TTS_PLANS_LIST } from "../../../service/url";
import { USER_ROLES } from '../../../utilities/constant';

import { validateEmail } from '../../../utilities/helpers'
import "../../../assets/custom/css/custom.css";
import Select from 'react-select';
import { Storage } from "../../../utilities/setting";
import {
  FiUser,
  FiMail,
  FiCalendar,
  FiLock,
  FiShield,
  FiEye,
  FiEyeOff,
  FiInfo,
  FiUserPlus,
  FiSend,
  FiCheckCircle,
} from "react-icons/fi";
import { FaBuilding } from "react-icons/fa";

function IconField({ icon: Icon, children, hasTrailing, trailing }) {
  return (
    <div
      className={`ccf-input-with-icon${hasTrailing ? " ccf-input-with-icon--trailing" : ""}${
        trailing ? " ccf-input-with-icon--icon-right" : ""
      }`}
    >
      {Icon && !trailing && (
        <span className="ccf-input-with-icon__icon">
          <Icon size={18} />
        </span>
      )}
      {children}
      {trailing && (
        <span className="ccf-input-with-icon__icon ccf-input-with-icon__icon--right">
          {trailing}
        </span>
      )}
    </div>
  );
}

const UserAdd = () => {
  const navigate = useNavigate();
  const [isOwnCompany, setIsOwnCompany] = useState(false);
  const { checkAuth } = useAuth();
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [aclSettingList, setAClSettingList] = useState([]);
  const [selectedACL, setSelectedACL] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isReseller, setIsReseller] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [loading, setLoading] = useState(true);
  const [isCompanyAdmin, setCompanyAdmin] = useState(false);
  const [isCallCenterAdmin, setCallCenterAdmin] = useState(false);
  const [channel, setChannel] = useState(0);
  const [callCenterAdminAgent, setCallCenterAdminAgent] = useState(0);
  const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
  const [agent, setAgent] = useState(0);
  const [liveAgent, setLiveAgent] = useState(0);
  const [selectedFlowType, setSelectedFlowType] = useState("");
  const [companyUserRole, setCompanyUserRole] = useState(false);
  const [availableLicence, setAvailableLicence] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [superAdminData, setSuperAdminData] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [parentExpiryDate, setParentExpiryDate] = useState(null);
  const [errors, setErrors] = useState({
    role_ccagent: "",
    role_ccteamlead: "",
    agent: "",
    channel: "",
    live_agent: ""
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(null);

  const [emailError, setEmailError] = useState("");
  const [companyList, setCompanyList] = useState([])
  const [selectedCompany, setSelectedCompany] = useState("")
  const [callCenterList, setCallCenterList] = useState([])
  const [selectedCallCenter, setSelectedCallCenter] = useState("")
  const [loggedUserParent, setLoggedUserParent] = useState("")
  const [loggedUserSuperParent, setLoggedUserSuperParent] = useState("")
  const [loggedUserSuperSuperParent, setLoggedUserSuperSuperParent] = useState("")
  const [existingUsernames, setExistingUsernames] = useState([]);
  const [usernameTakenMessage, setUsernameTakenMessage] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [nameError, setNameError] = useState("");
  const [tts_plan_id, setTtsPlanId] = useState(null);
  const [showTtsPlanId, setShowTtsPlanId] = useState(false);
  const [ttsPlanList, setTtsPlanList] = useState([]);
  const [emailFieldError, setEmailFieldError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [aclError, setAclError] = useState("");
  const [signupEmailOtp, setSignupEmailOtp] = useState("");
  const [signupEmailToken, setSignupEmailToken] = useState("");
  const [emailVerifiedForCreate, setEmailVerifiedForCreate] = useState(false);
  const [signupEmailBusy, setSignupEmailBusy] = useState(false);
  const [userTypeError, setUserTypeError] = useState("");
  const [expiryDateError, setExpiryDateError] = useState("");
  const [passwordRules, setPasswordRules] = useState({
    length: false,
    upper: false,
    lower: false,
    number: false,
    special: false,
    space: true,
  });

  /** Logged-in user's ACL: TTS module enabled (any of TTS / tts / Tts keys with a true permission). */
  const [creatorHasTtsAccess, setCreatorHasTtsAccess] = useState(false);
  const [accountType, setAccountType] = useState("0");
  const [parentAccountType, setParentAccountType] = useState(null);

  function getKeysWithTrueValues(moduleOperations) {
    if (!moduleOperations || typeof moduleOperations !== "object") return [];
    return Object.keys(moduleOperations).filter((key) => {
      const permissions = moduleOperations[key];
      return Object.values(permissions).some((value) => value === true);
    });
  }

  function moduleListIncludesTts(modules) {
    if (!modules?.length) return false;
    return modules.some((m) => m === "TTS" || m === "tts" || m === "Tts");
  }

  function aclSettingsHasTtsModule(aclSettings) {
    if (!aclSettings) return false;
    let mo = aclSettings.module_operations;
    if (typeof mo === "string") {
      try {
        mo = JSON.parse(mo || "{}");
      } catch {
        return false;
      }
    }
    const modules = getKeysWithTrueValues(mo || {});
    return moduleListIncludesTts(modules);
  }

  useEffect(() => {
    if (!loading) {
      getApiCall(`${API_USERS_LIST}?role=noRole`, {})
        .then((data) => {
          const usernames = data.map((user) => user.username);
          setExistingUsernames(usernames);
        })
        .catch((error) => console.log("ERROR", error));
    }
  }, [loading]);

  useEffect(() => {
    if (!creatorHasTtsAccess) {
      setShowTtsPlanId(false);
      return;
    }
    if (selectedACL) {
      const selectedAclDetails = aclSettingList?.filter((item) => {
        return item?.id == selectedACL;
      });
      if (selectedAclDetails && selectedAclDetails?.length > 0) {
        const modules = getKeysWithTrueValues(
          JSON.parse(selectedAclDetails?.[0]?.module_operations || "{}")
        );
        setShowTtsPlanId(moduleListIncludesTts(modules));
      }
    } else {
      setShowTtsPlanId(false);
    }
  }, [selectedACL, aclSettingList, creatorHasTtsAccess]);

  useEffect(() => {
    if (!showTtsPlanId) {
      setTtsPlanId(null);
    }
  }, [showTtsPlanId]);

  const validatePassword = (value) => {
    const errors = {
      length: value.length >= 8,
      upper: /[A-Z]/.test(value),
      lower: /[a-z]/.test(value),
      number: /[0-9]/.test(value),
      special: /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/+=~`]/.test(value),
      space: !/\s/.test(value),
    };

    if (Object.values(errors).every(Boolean)) {
      setPasswordError("");
    } else {
      setPasswordError("Password does not meet requirements");
    }

    setPasswordRules(errors);
  };

  useEffect(() => {
    async function superadminCheck() {
      const user = JSON.parse(Storage.getItem('user'));
      // const availableLicence = user?.sub_user_licence?.available_licence
      // setAvailableLicence(availableLicence)
      if (user.role === USER_ROLES.SUPERADMIN) {
        setIsSuperAdmin(true);
        setSuperAdminData(user);
      }

      if (
        user?.role === USER_ROLES.SUPERADMIN ||
        user?.role === USER_ROLES.SUB_SUPERADMIN
      ) {
        setCreatorHasTtsAccess(true);
      } else {
        setCreatorHasTtsAccess(aclSettingsHasTtsModule(user?.acl_settings));
      }

      if (user) {
          if (user && user.assignedCompany && user.assignedCompany?.is_own_company) {
            setIsOwnCompany(true);
          }
          // Store parent user's expiry date for validation
          setParentExpiryDate(user.expiry_date || null);
          
      }
 if (user.account_type !== undefined && user.account_type !== null) {
  setParentAccountType(Number(user.account_type));
  setAccountType(String(user.account_type));
} else {
  setAccountType("0");
}

      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        setCompanyAdmin(true);

        const hasOwnAssignedCompany = Boolean(user?.assignedCompany?.is_own_company);
        setIsOwnCompany(hasOwnAssignedCompany);
        if (hasOwnAssignedCompany) {
          setCompanyList([{
            id: user?.assignedCompany?.id,
            name: user?.assignedCompany?.name
          }]);
          setSelectedCompany(user?.assignedCompany?.id || "");
        } else {
          setCompanyList([]);
          setSelectedCompany("");
        }
      }
      if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
        setCallCenterList([{
          id: user?.callcenter?.id,
          name: user?.callcenter?.name
        }])

        setSelectedCallCenter(user?.callcenter?.id)
        setCallCenterAdmin(true);
      }
      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        setCompanyUserRole(true);
      }
      if (user.role === USER_ROLES.RESELLER) {
        setIsReseller(true);
        setLoggedUserParent(user.role)
        setLoggedUserSuperParent(user?.createdByUser?.role)
        setLoggedUserSuperSuperParent(user?.createdByUser?.createdByUser?.role)
      }
      setLoading(false);
    }
    superadminCheck();
  }, []);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    if (loading) return;

    if (!selectedUserType) {
      setAClSettingList([]);
      setSelectedACL("");
      return;
    }

    setSelectedACL("");
    getApiCall(
      `${API_ACL_SETTING_LIST}?target_role=${encodeURIComponent(selectedUserType)}`,
      {}
    )
      .then(onAClSettingListSuccess)
      .catch(onError);
  }, [loading, selectedUserType]);

  useEffect(() => {
    if (!loading) {
      getApiCall(API_COMPANY_LIST, {})
        .then(onCompanyListSuccess)
        .catch(onError);
    }
  }, [loading, superAdminData, isSuperAdmin]);

  function onCompanyListSuccess(resp) {
    if (isCompanyAdmin) {
      // For own-company admins keep only assigned company in dropdown.
      if (isOwnCompany) return;
      // For normal company admins show API companies (their created companies).
      setCompanyList(resp);
      return;
    }

    setCompanyList(resp)
    if (isSuperAdmin && superAdminData) {
      const filteredCompanies = resp.filter((item) => {
        return item.created_by == superAdminData?.id
      });
      setCompanyList(filteredCompanies);
    }
  }

  useEffect(() => {
    if (!loading) {
      getApiCall(API_CALL_CENTRE_LIST, {})
        .then(onCallcenterListSuccess)
        .catch(onError);
    }
  }, [loading]);

  function onCallcenterListSuccess(resp) {
    if (!isCallCenterAdmin) {
      setCallCenterList(resp)
    }
  }

  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);


  function onAClSettingListSuccess(resp) {
      setAClSettingList(resp);
  }

  // Auto-select default ACL when user type (role) changes
  useEffect(() => {
    if (!selectedUserType || !aclSettingList.length) return;

    const defaultAcl = aclSettingList.find(
      (acl) => acl.default_for_role === selectedUserType
    );

    if (defaultAcl) {
      setSelectedACL(String(defaultAcl.id));
    }
  }, [selectedUserType, aclSettingList]);

  const showCompanyAssign =
    selectedUserType === USER_ROLES.RESELLER ||
    selectedUserType === USER_ROLES.COMPANY_ADMIN;

  useEffect(() => {
    getApiCall(API_TTS_PLANS_LIST).then((resp) => { 
      if (isSuperAdmin && superAdminData) {
        const filteredPlans = resp?.filter((item) => {
          return item.user_id == superAdminData?.id
        });
        setTtsPlanList(filteredPlans);
      } else {
        setTtsPlanList(resp) 
      }
    }).catch((error) => { toast.error(JSON.stringify(error)) })
  }, [superAdminData, isSuperAdmin]);


  function validateForm() {
    let valid = true;
    setEmailFieldError("");
    setPasswordError("");
    setConfirmPasswordError("");
    setAclError("");
    setUserTypeError("");
    setExpiryDateError("");
    if (!validateUsername(username)) {
      valid = false;
      if (!username.trim()) {
        toast.error("Username required");
      } else {
        toast.error(usernameError || "Invalid username format");
      }
    }
    if (!validateName(name)) {
      valid = false;
      if (!name.trim()) {
        toast.error("Name required");
      } else {
        toast.error(nameError || "Invalid name format");
      }
    }
    if (!email.trim()) {
      valid = false;
      setEmailFieldError("Email is required");
      toast.error("Email required");
    } 
    if (!password.trim()) {
      valid = false;
      setPasswordError("Password is required");
      toast.error("Password required");
    } else if (passwordError) {
      valid = false;
      setPasswordError("Password must be at least 6 characters");
      toast.error("Password must be of minimum 6 characters");
    } 
    if (!confirmPassword.trim()) {
      valid = false;
      setConfirmPasswordError("Confirm Password is required");
      toast.error("Confirm password required");
    } else if (password.trim() != confirmPassword.trim()) {
      valid = false;
      setConfirmPasswordError("Passwords do not match");
      toast.error("Password and confirm password not matching");

    } 
    if (showCompanyAssign) {
      if (selectedCompany === "" || selectedCompany === null || !selectedCompany) {
        valid = false;
        toast.error("Company is required");
      }
    }

    if (selectedUserType == "role_ccadmin") {
      if (selectedFlowType === "" || selectedFlowType === null) {
        valid = false;
        toast.error("Flow type required");
      }
    }
   if (accountType === "" || accountType === null || accountType === undefined) {
  valid = false;
  toast.error("Account Type is required");
} else if (![0, 1].includes(Number(accountType))) {
  valid = false;
  toast.error("Account Type must be Promotional or Transactional");
}

  if ((isSuperAdmin || isCompanyAdmin || isCallCenterAdmin || isReseller) && !selectedUserType) {
  valid = false;
  setUserTypeError("User Type is required");
  toast.error("UserType required");
}

    if (
      selectedUserType &&
      !selectedACL &&
      selectedUserType !== USER_ROLES.CALL_CENTRE_AGENT
    ) {
      valid = false;
      setAclError("ACL Settings is required");
      toast.error("ACL Settings is required");
    }

    if (emailError) {
      valid = false;
      toast.error("Enter correct Email");
    }

    if (!emailVerifiedForCreate || !signupEmailToken) {
      valid = false;
      toast.error("Verify this email first: use Send code, then enter the OTP and click Verify OTP.");
    }

    if (isSuperAdmin || isCompanyAdmin || isCallCenterAdmin) {
      if (!selectedUserType.trim()) {
        valid = false;
        toast.error("UserType required");
      }
    }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
      if (!selectedCallCenter.trim()) {
        valid = false;
        toast.error("Callcenter required");
      }
    }

    if (!expiryDate) {
      valid = false;
      setExpiryDateError("Expiry date is required");
      toast.error("Expiry Date required");
    } else {
      // Validate expiry date format and range
      const selectedDate = new Date(expiryDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      // Check if date is valid
      if (isNaN(selectedDate.getTime())) {
        valid = false;
        toast.error("Invalid expiry date format. Please select a valid date.");
      } else {
        // Check if date is in the past
        if (selectedDate < today) {
          valid = false;
          toast.error("Expiry Date cannot be in the past. Please select a future date.");
        } else {
          // Check if date is too far in the future (max 100 years from today)
          const maxDate = new Date();
          maxDate.setFullYear(maxDate.getFullYear() + 100);
          maxDate.setHours(0, 0, 0, 0);
          
          if (selectedDate > maxDate) {
            valid = false;
            toast.error("Expiry Date cannot be more than 100 years in the future. Please select a reasonable date.");
          } else {
            // Check if date is greater than parent expiry date
            if (parentExpiryDate) {
              const parentDate = new Date(parentExpiryDate);
              parentDate.setHours(0, 0, 0, 0);
              
              if (selectedDate > parentDate) {
                valid = false;
                setExpiryDateError("Expiry date cannot be greater than parent user's expiry date");
                toast.error("Expiry Date cannot be greater than parent user's expiry date.");
              }
            }
          }
        }
      }
    }

    if (showTtsPlanId) {
      if (!tts_plan_id) {
        valid = false;
        toast.error("TTS Plan is required when selecting ACL having TTS");
      }
    }

    return valid;
  }


  const updateLocalStorage = async (finalData) => {
    try {
      Storage.setItem('user', JSON.stringify(finalData));
    } catch (error) {
      console.error('Error updating available licences:', error);
    }
  };


  async function submitForm() {
    setIsLoading(true);
    setButtonDisable(true);

    if (!validateForm()) {
      setIsLoading(false);
      setButtonDisable(false);
      return;
    }

    if (Object.values(errors).some(value => value !== "")) {
      toast.error("Enter All correct values");
      setIsLoading(false);
      setButtonDisable(false);
      return;
    }

    const sub_licence = {
      role_ccagent: Number(callCenterAdminAgent),
      role_ccteamlead: Number(callCenterAdminTeamlead),
      agent: Number(agent),
      channel: Number(channel),
      live_agent: Number(liveAgent)
    };

    const params = {
      username,
      password,
      name,
      email,
      signup_email_token: signupEmailToken,
      acl_settings: (selectedACL === "") ? null : selectedACL,
      ...(selectedUserType == "role_ccadmin" && { flow_type: Number(selectedFlowType) })
    };

    if (selectedUserType === USER_ROLES.RESELLER || selectedUserType === USER_ROLES.COMPANY_ADMIN) {
      params.company = selectedCompany !== "" ? selectedCompany : null;
    }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
      params.callcenterId = selectedCallCenter
    }
    if (!selectedUserType || selectedUserType.trim() === "") {
  toast.error("User Type is required");
  setIsLoading(false);
  setButtonDisable(false);
  return;
}
params.role = selectedUserType;

    // let finalData
    // if (!isReseller && !isSuperAdmin) {
    //   const { user, newAvailableLicences } = await updateAvailableLicences(sub_licence);
    //   finalData = user;
    //   params.parent_licence = newAvailableLicences;
    // }

    params.expiry_date = expiryDate;
    params.account_type = Number(accountType);

    if (showTtsPlanId) {
      params.tts_plan_id = tts_plan_id;
    }

    try {
      const resp = await postApiCall(API_USERS_SIGNUP, params);

      if (resp) {
        await onUserCreateSuccess(resp);
      } else {
        throw new Error(resp?.message || "User creation failed");
      }
    } catch (error) {
      onUserCreateError(error);
    }
    finally {
      setIsLoading(false);
    }
  }

  async function onUserCreateSuccess(resp) {
    // if (!isReseller && !isSuperAdmin) {
    //   await updateLocalStorage(finalData);
    //   setAvailableLicence(finalData?.sub_user_licence?.available_licence)
    // }

    toast.success("User created successfully. Email was verified before signup.");

    setTimeout(() => {
      navigate(`/${ROUTES.USERS.LIST}`);
    }, 1500);
  }

  function onUserCreateError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      setButtonDisable(false);
      setIsLoading(false);
      toast.error(JSON.stringify(err));
    }
  }


  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      console.log(err)
    }
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(validateEmail(value));
    setSignupEmailToken("");
    setSignupEmailOtp("");
    setEmailVerifiedForCreate(false);
  };

  const sendSignupEmailCode = async () => {
    if (!email.trim() || validateEmail(email)) {
      toast.error("Enter a valid email before sending a code.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      await postApiCall(API_SIGNUP_EMAIL_SEND_CODE, { email: email.trim() });
      setSignupEmailToken("");
      setEmailVerifiedForCreate(false);
      toast.success("Verification code sent. Check the inbox for this email.");
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Could not send verification code");
    } finally {
      setSignupEmailBusy(false);
    }
  };

  const verifySignupEmailOtp = async () => {
    if (!email.trim() || validateEmail(email)) {
      toast.error("Enter a valid email.");
      return;
    }
    if (!signupEmailOtp || signupEmailOtp.length !== 6) {
      toast.error("Enter the 6-digit code from the email.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      const data = await postApiCall(API_SIGNUP_EMAIL_VERIFY_CODE, {
        email: email.trim(),
        otp: signupEmailOtp.trim(),
      });
      if (data?.signupEmailToken) {
        setSignupEmailToken(data.signupEmailToken);
        setEmailVerifiedForCreate(true);
        toast.success("Email verified. You can submit the form to create the user.");
      } else {
        toast.error("Unexpected response from server");
      }
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Verification failed");
      setEmailVerifiedForCreate(false);
      setSignupEmailToken("");
    } finally {
      setSignupEmailBusy(false);
    }
  };

  const validateUsername = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setUsernameError("Username is required");
      return false;
    }
    if (trimmedValue.length < 3 || trimmedValue.length > 50) {
      setUsernameError("Username must be between 3 and 50 characters");
      return false;
    }
    if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
      setUsernameError("Username can only contain letters, numbers, underscores, and spaces");
      return false;
    }
    setUsernameError("");
    return true;
  };

  const validateName = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setNameError("Name is required");
      return false;
    }
    if (trimmedValue.length < 2 || trimmedValue.length > 100) {
      setNameError("Name must be between 2 and 100 characters");
      return false;
    }
    if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
      setNameError("Name can only contain letters, numbers, underscores, and spaces");
      return false;
    }
    setNameError("");
    return true;
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    validateUsername(value);

    const trimmedValue = value.trim().toLowerCase();

    if (trimmedValue.length >= 1) {
      const isTaken = existingUsernames.some(
        (existing) => existing.toLowerCase() === trimmedValue
      );

      if (isTaken) {
        setButtonDisable(true)
        setUsernameTakenMessage(`Username "${trimmedValue}" already exists`);
      } else {
        setButtonDisable(false);
        setUsernameTakenMessage("");
      }
    } else {
      setUsernameTakenMessage("");
      setButtonDisable(true);
    }
  };

  // Compute date bounds for child expiry (cannot exceed parent expiry)
  const todayStr = new Date().toISOString().split("T")[0];

  const computedMaxDateStr = (() => {
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 100);
    return maxDate.toISOString().split("T")[0];
  })();

  const parentMaxDateStr = parentExpiryDate
    ? new Date(parentExpiryDate).toISOString().split("T")[0]
    : null;

  const childMaxExpiryDateStr =
    parentMaxDateStr && parentMaxDateStr < computedMaxDateStr
      ? parentMaxDateStr
      : computedMaxDateStr;

const handlePasswordChange = (e) => {
  const value = e.target.value;
  setPassword(value);

  let errors = [];

  // Rule checks
  if (value.length < 8) {
    errors.push("At least 8 characters");
  }
  if (!/[A-Z]/.test(value)) {
    errors.push("At least 1 uppercase letter");
  }
  if (!/[a-z]/.test(value)) {
    errors.push("At least 1 lowercase letter");
  }
  if (!/[0-9]/.test(value)) {
    errors.push("At least 1 number");
  }
  if (!/[!@#$%^&*(),.?\":{}|<>]/.test(value)) {
    errors.push("At least 1 special character");
  }
  if (/\s/.test(value)) {
    errors.push("No spaces allowed");
  }

  if (value.length === 0) {
    setPasswordError("");
  } else if (errors.length > 0) {
    setPasswordError(errors);
  } else {
    setPasswordError("");
  }

  if (confirmPassword) {
    setPasswordMatch(value === confirmPassword);
  }
};

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-none" />
              <Card.Body className="user-create-form-card">
                <div className="new-user-info company-create-form user-create-form">
                  <div className="user-create-form__hero">
                    <div className="user-create-form__hero-left">
                      <span className="user-create-form__hero-icon" aria-hidden="true">
                        <FiUser size={22} />
                      </span>
                      <div>
                        <h5 className="user-create-form__hero-title">New User Information</h5>
                        <p className="user-create-form__hero-subtitle">
                          Create a new user and assign access within the system.
                        </p>
                      </div>
                    </div>
                    <div className="user-create-form__required-note">
                      <FiInfo size={14} aria-hidden="true" />
                      <span>
                        All fields marked with <span className="text-danger">*</span> are required
                      </span>
                    </div>
                  </div>

                  <form autoComplete="off">
                    <div className="row user-create-form__row">
                      <Form.Group className="col-12 col-lg-4 form-group mb-0">
                        <Form.Label>
                          Username <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiUser}>
                          <Form.Control
                            type="text"
                            id="username"
                            className={`ccf-input-with-icon__control${usernameError ? " is-invalid" : ""}`}
                            placeholder="Enter username"
                            autoComplete="off"
                            maxLength={50}
                            value={username}
                            readOnly
                            onFocus={(e) => e.target.removeAttribute("readOnly")}
                            onChange={handleUsernameChange}
                            onBlur={(e) => validateUsername(e.target.value)}
                            required
                          />
                        </IconField>
                        {usernameError && <div className="invalid-feedback d-block">{usernameError}</div>}
                        {usernameTakenMessage && <small className="text-danger">{usernameTakenMessage}</small>}
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-4 form-group mb-0">
                        <Form.Label>
                          Full Name <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiUser}>
                          <Form.Control
                            type="text"
                            id="name"
                            className={`ccf-input-with-icon__control${nameError ? " is-invalid" : ""}`}
                            placeholder="Enter full name"
                            maxLength={100}
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                              validateName(e.target.value);
                            }}
                            onBlur={(e) => validateName(e.target.value)}
                            required
                          />
                        </IconField>
                        {nameError && <div className="invalid-feedback d-block">{nameError}</div>}
                      </Form.Group>

                      {(isSuperAdmin || isCompanyAdmin || isCallCenterAdmin || isReseller) && (
                        <Form.Group className="col-12 col-lg-4 form-group mb-0">
                          <Form.Label>
                            Role <span className="text-danger">*</span>
                          </Form.Label>
                          <IconField icon={FiUserPlus}>
                            <Form.Select
                              id="userType"
                              required
                              value={selectedUserType}
                              className={`ccf-input-with-icon__control ccf-input-with-icon__select${
                                userTypeError ? " is-invalid" : ""
                              }`}
                              onChange={(e) => setSelectedUserType(e.target.value)}
                            >
                            <option value="" disabled hidden>
                              Select role
                            </option>
                            {(isOwnCompany && isCompanyAdmin) && (
                              <>
                                <option key="2" value="role_ccadmin">
                                  Call Center User
                                </option>
                              </>
                            )}
                            {isSuperAdmin && (
                              <>
                                <option key="1" value="role_sub_superadmin">
                                  Sub-Superadmin
                                </option>
                                <option key="2" value="role_reseller">
                                  Reseller
                                </option>
                              </>
                            )}
                            {isCompanyAdmin && !isOwnCompany && (
                              <>
                                <option key="1" value="role_cadmin">
                                  Company User
                                </option>
                                <option key="1" value="role_ccadmin">
                                  Call Centre User
                                </option>
                              </>
                            )}
                            {isCallCenterAdmin && (
                              <>
                                <option key="1" value="role_ccteamlead">
                                  Call Centre Team Lead
                                </option>
                                {/* <option key="2" value="role_ccagent">
                                  Call Centre Agent
                                </option> */}
                              </>
                            )}
                            {isReseller && isOwnCompany && (
                              <>
                                <option key="1" value="role_ccadmin">
                                  Call Centre User
                                </option>
                              </>
                            )}
                            {isReseller && !isOwnCompany && (
                              <>
                                {(loggedUserParent === USER_ROLES.RESELLER &&
                                  loggedUserSuperParent === USER_ROLES.RESELLER &&
                                  loggedUserSuperSuperParent === USER_ROLES.RESELLER) ? (
                                  <option key="2" value="role_cadmin">
                                    Company User
                                  </option>
                                ) : (
                                  <>
                                    <option key="1" value="role_reseller">
                                      Reseller
                                    </option>
                                    <option key="2" value="role_cadmin">
                                      Company User
                                    </option>
                                  </>
                                )}
                              </>
                            )}
                          </Form.Select>
                            </IconField>
                          {userTypeError && <div className="invalid-feedback d-block">{userTypeError}</div>}
                        </Form.Group>
                      )}
                    </div>

                    <div className="row user-create-form__row">
                      <Form.Group className="col-12 col-lg-8 form-group mb-0 user-create-form__email-col">
                        <Form.Label>
                          Email <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiMail}>
                          <Form.Control
                            type="email"
                            id="email"
                            className={`ccf-input-with-icon__control${
                              emailFieldError ? " is-invalid" : ""
                            }${emailVerifiedForCreate ? " is-verified-email" : ""}`}
                            placeholder="Enter email address"
                            autoComplete="off"
                            maxLength={100}
                            value={email}
                            onChange={handleEmailChange}
                            required
                          />
                        </IconField>
                        {emailFieldError && (
                          <div className="invalid-feedback d-block">{emailFieldError}</div>
                        )}
                        <div className="default-user-email-verify user-create-form__email-verify">
                          <IconField icon={FiShield}>
                            <Form.Control
                              type="text"
                              inputMode="numeric"
                              className="ccf-input-with-icon__control default-user-email-verify__otp"
                              placeholder="6-digit code"
                              maxLength={6}
                              value={signupEmailOtp}
                              onChange={(e) =>
                                setSignupEmailOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
                              }
                              disabled={signupEmailBusy}
                            />
                          </IconField>
                          <Button
                            type="button"
                            variant="outline-primary"
                            size="sm"
                            className="default-user-email-verify__btn default-user-email-verify__btn--send"
                            disabled={
                              signupEmailBusy || !email.trim() || !!validateEmail(email)
                            }
                            onClick={sendSignupEmailCode}
                          >
                            <FiSend size={14} className="me-1" />
                            Send Code
                          </Button>
                          <Button
                            type="button"
                            variant="outline-success"
                            size="sm"
                            className="default-user-email-verify__btn default-user-email-verify__btn--verify"
                            disabled={signupEmailBusy || signupEmailOtp.length !== 6}
                            onClick={verifySignupEmailOtp}
                          >
                            <FiCheckCircle size={14} className="me-1" />
                            Verify OTP
                          </Button>
                          {emailVerifiedForCreate && (
                            <span className="text-success small default-user-email-verify__ok">
                              Email verified
                            </span>
                          )}
                        </div>
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-4 form-group mb-0">
                        <Form.Label>
                          Access Valid Till (User Expiry Date) <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField trailing={<FiCalendar size={18} />}>
                          <Form.Control
                            type="date"
                            className={`ccf-input-with-icon__control ccf-input-with-icon__control--date${
                              expiryDateError ? " is-invalid" : ""
                            }`}
                            min={todayStr}
                            max={childMaxExpiryDateStr}
                            value={expiryDate || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value && value > childMaxExpiryDateStr) {
                                toast.error(
                                  "Expiry Date cannot be greater than parent user's expiry date."
                                );
                                setExpiryDate(childMaxExpiryDateStr);
                              } else {
                                setExpiryDate(value);
                              }
                            }}
                            required
                          />
                        </IconField>
                        {expiryDateError && (
                          <div className="invalid-feedback d-block">{expiryDateError}</div>
                        )}
                      </Form.Group>

                    </div>

                    <div className="row user-create-form__row">
                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>
                          Password <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiLock} hasTrailing>
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            id="pass"
                            className="ccf-input-with-icon__control ccf-input-with-icon__control--trailing"
                            placeholder="Enter password"
                            autoComplete="new-password"
                            maxLength={100}
                            value={password}
                            readOnly
                            onFocus={(e) => e.target.removeAttribute("readOnly")}
                            onChange={handlePasswordChange}
                            required
                          />
                          <button
                            type="button"
                            className="ccf-input-with-icon__trailing-btn"
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label={showPassword ? "Hide password" : "Show password"}
                          >
                            {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            <span className="ms-1">Show</span>
                          </button>
                        </IconField>
                        <p className="user-create-form__field-hint">
                          Password must be at least 8 characters.
                        </p>
                        {Array.isArray(passwordError) && passwordError.length > 0 && (
                          <div className="user-create-form__password-hints">
                            {passwordError.map((err, index) => (
                              <div key={index}>• {err}</div>
                            ))}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>
                          Confirm Password <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiLock} hasTrailing>
                          <Form.Control
                            type={showConfirmPassword ? "text" : "password"}
                            id="rpass"
                            className={`ccf-input-with-icon__control ccf-input-with-icon__control--trailing${
                              confirmPasswordError ? " is-invalid" : ""
                            }`}
                            placeholder="Confirm password"
                            autoComplete="new-password"
                            maxLength={100}
                            value={confirmPassword}
                            onChange={(e) => {
                              const value = e.target.value;
                              setConfirmPassword(value);
                              if (password) {
                                setPasswordMatch(password === value);
                              }
                            }}
                            required
                          />
                          <button
                            type="button"
                            className="ccf-input-with-icon__trailing-btn"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            aria-label={
                              showConfirmPassword ? "Hide password" : "Show password"
                            }
                          >
                            {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            <span className="ms-1">Show</span>
                          </button>
                        </IconField>
                        {confirmPasswordError && (
                          <div className="invalid-feedback d-block">{confirmPasswordError}</div>
                        )}
                        {confirmPassword && (
                          <small className={passwordMatch ? "text-success" : "text-danger"}>
                            {passwordMatch ? "✔ Passwords match" : "✖ Passwords do not match"}
                          </small>
                        )}
                      </Form.Group>
                    </div>

                    <div className="row user-create-form__row">
                      <Form.Group className="col-12 col-md-6 form-group mb-0 user-create-form__acl-col">
                        <Form.Label>
                          ACL Settings
                          {selectedUserType &&
                            selectedUserType !== USER_ROLES.CALL_CENTRE_AGENT && (
                              <span className="text-danger"> *</span>
                            )}
                        </Form.Label>
                        <IconField icon={FiShield}>
                          <Form.Select
                            id="aclSetting"
                            required={
                              !!selectedUserType &&
                              selectedUserType !== USER_ROLES.CALL_CENTRE_AGENT
                            }
                            disabled={!selectedUserType}
                            value={selectedACL}
                            className={`ccf-input-with-icon__control ccf-input-with-icon__select${
                              aclError ? " is-invalid" : ""
                            }`}
                            onChange={(e) => setSelectedACL(e.target.value)}
                          >
                            <option value="">Select ACL</option>
                            {aclSettingList.map((val, idx) => (
                              <option key={idx} value={val.id}>
                                {val.acl_name}
                              </option>
                            ))}
                          </Form.Select>
                        </IconField>
                        <p className="user-create-form__field-hint">
                          Select the access control level for this user.
                        </p>
                        {aclError && <div className="invalid-feedback d-block">{aclError}</div>}
                      </Form.Group>

                      <Form.Group className="col-12 col-md-6 form-group mb-0">
                        <Form.Label>
                          Account Type <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiShield}>
                          <Form.Select
                            id="accountType"
                            value={accountType}
                            className={`ccf-input-with-icon__control ccf-input-with-icon__select${
                              accountType === "" ? " is-invalid" : ""
                            }`}
                            onChange={(e) => setAccountType(e.target.value)}
                          >
                            <option value="">Select Account Type</option>
                            {parentAccountType === null || parentAccountType === undefined ? (
                              <>
                                <option value="0">Promotional</option>
                                <option value="1">Transactional</option>
                              </>
                            ) : Number(parentAccountType) === 0 ? (
                              <option value="0">Promotional</option>
                            ) : (
                              <option value="1">Transactional</option>
                            )}
                          </Form.Select>
                        </IconField>
                        <p className="user-create-form__field-hint">
                          Promotional or transactional messaging account.
                        </p>
                      </Form.Group>

                      {showCompanyAssign && (
                        <Form.Group className="col-12 col-md-6 form-group mb-0 user-create-form__company-col">
                          <Form.Label>
                            Assign Company <span className="text-danger">*</span>
                          </Form.Label>
                          <IconField icon={FaBuilding}>
                            <Form.Select
                              id="assignCompany"
                              required
                              value={selectedCompany}
                              disabled={isOwnCompany && isCompanyAdmin}
                              className="ccf-input-with-icon__control ccf-input-with-icon__select"
                              onChange={(e) => setSelectedCompany(e.target.value)}
                            >
                              <option value="">Select company</option>
                              {companyList.map((val, idx) => (
                                <option key={idx} value={val.id}>
                                  {val.name}
                                </option>
                              ))}
                            </Form.Select>
                          </IconField>
                        </Form.Group>
                      )}
                    </div>

                    {/* Row with licence dropdowns and other settings */}
                    {(isSuperAdmin || isCompanyAdmin || isCallCenterAdmin || isReseller) ? (
                      <div className="row user-create-form__row">
                        {selectedUserType === "role_ccadmin" && (
                          <Form.Group className="col-md-6 form-group">
                              <Form.Label>
                              Select Flow Type <span style={{ color: "red", margin: "0 4px" }}>*</span>
                             </Form.Label>
                            <Form.Select
                              id="callCenterType"
                              required
                              value={selectedFlowType || ""}
                              className="p-2"
                              onChange={(e) => setSelectedFlowType(e.target.value)}
                            >
                              <option value="" disabled hidden>
                                Select Flow Type
                              </option>
                              <option value="0">Asterisk</option>
                              {/* <option value="1">Jambonz</option> */}
                            </Form.Select>
                          </Form.Group>
                        )}

                      </div>
                    ) : (
                      /* Row with only licence dropdown when userType is not rendered */
                      <>
                        {/* {isSuperAdmin && <div className="row">
                          <Form.Group className="col-md-6 form-group">
                            <Form.Select
                              id="licence"
                              required
                              value={licence}
                              className="p-2"
                              onChange={(e) => setSelectedLicence(e.target.value)}
                            >
                              <option value="" disabled hidden>
                                Select Licence
                              </option>
                              {Array.from({ length: 10 }, (_, i) => (
                                <option key={(i + 1) * 10} value={(i + 1) * 10}>
                                  {(i + 1) * 10}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </div>
                        } */}
                      </>
                    )}
                    {(selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) ? (
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Select Call Center <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Select
                          id="aclSetting"
                          required
                          value={selectedCallCenter}
                          className="p-2"
                          onChange={(e) => setSelectedCallCenter(e.target.value)}
                        >
                          <option value={""}>Call Center</option>
                          {callCenterList.map(function (val, idx) {
                            return (
                              <option key={idx} value={val.id}>
                                {val.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    ) : (
                      <></>
                    )}

                    {showTtsPlanId &&
                    <>
                      <Form.Group className="col-md-6 mb-5">
                        <Form.Label>Select TTS Plan <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Select
                          id="tts_plan_id"
                          required
                          value={tts_plan_id}
                          className="p-2"
                          onChange={(e) => setTtsPlanId(e.target.value)}
                        >
                          <option value={""}>Select TTS Plan</option>
                          {ttsPlanList.map(function (val, idx) {
                            return (
                              <option key={idx} value={val.id}>
                                {val.plan_name}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </>}
                    <div className="form-actions user-create-form__actions">
                    <Button
                      onClick={async () => {
                        submitForm();
                      }}
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          &nbsp; Adding...
                        </>
                      ) : (
                        "Add New User"
                      )}
                    </Button>
                    </div>
                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};

export default UserAdd;
